import initSocketCicleMix from "@/code-lab/component/mixins/init-socket-cicle-mix.js"
export default {
  mixins: [ initSocketCicleMix ],
  async created () {
    await this.initSocket()
  },
  render: h => h()
}
